import { gql } from '@apollo/client';

export const QUERY_PROJECTS = gql`
    query projects($filters: ProjectFiltersInput, $pagination: PaginationArg = {}, $sort: [String] = []) {
        projects(filters: $filters, pagination: $pagination, sort: $sort) {
            data {
                id
                attributes {
                    name
                    logo {
                        data {
                            id
                            attributes {
                                url
                            }
                        }
                    }
                    color
                    cover {
                        data {
                            id
                            attributes {
                                url
                            }
                        }
                    }
                }
            }
            meta {
                pagination {
                    page
                    pageSize
                    pageCount
                    total
                }
            }
        }
    }
`;

export const QUERY_PROJECT = gql`
    query project($id: ID!) {
        project(id: $id) {
            data {
                id
                attributes {
                    name
                    logo {
                        data {
                            id
                            attributes {
                                url
                            }
                        }
                    }
                    color
                    cover {
                        data {
                            id
                            attributes {
                                url
                            }
                        }
                    }
                    links
                    levels
                    experiences
                }
            }
        }
    }
`;

export const MUTATION_CREATE_PROJECT = gql`
    mutation createProject($data: ProjectInput!) {
        createProject(data: $data) {
            data {
                id
            }
        }
    }
`;

export const MUTATION_UPDATE_PROJECT = gql`
    mutation updateProject($id: ID!, $data: ProjectInput!) {
        updateProject(id: $id, data: $data) {
            data {
                id
            }
        }
    }
`;
